import { useState } from "react";

import { filterBy } from "neetocist";
import { Typography, Select } from "neetoui";
import { useTranslation } from "react-i18next";

import Codeblock from "components/Codeblock";

import { SUPPORTED_LANGUAGES } from "./constants";
import { generateCode } from "./utils";

const Code = ({
  id,
  selectedEmbed,
  embedScriptLink,
  extraArgs,
  inlineWrapperStyle,
  iframeStyle,
  supportedLanguages,
  customization,
}) => {
  const { t } = useTranslation();

  const supportedLanguagesOptions = filterBy(
    { value: value => supportedLanguages?.includes(value) },
    SUPPORTED_LANGUAGES
  );

  const [selectedLanguage, setSelectedLanguage] = useState(
    supportedLanguagesOptions[0]
  );

  const code = generateCode({
    id,
    selectedLanguage: selectedLanguage.value,
    type: selectedEmbed,
    customization,
    embedScriptLink,
    extraArgs,
    inlineWrapperStyle,
    iframeStyle,
  });

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <Typography style="h4">
          {t("neetoMolecules.productEmbed.embedCode")}
        </Typography>
        <Select
          className="w-28 flex-grow-0"
          options={supportedLanguagesOptions}
          size="small"
          strategy="fixed"
          value={selectedLanguage}
          onChange={setSelectedLanguage}
        />
      </div>
      <div
        className="neeto-molecules-embed__code-block relative w-full overflow-y-auto"
        data-testid="embed-code-block"
      >
        <Codeblock
          {...{ code }}
          codeblockProps={{
            "data-testid": `${selectedLanguage.value}-code-block`,
          }}
          copyButtonProps={{
            style: "primary",
            label: t("neetoMolecules.productEmbed.copyCode"),
          }}
        />
      </div>
    </div>
  );
};

export default Code;
